import { render, staticRenderFns } from "./FeedbackSurveyManage.vue?vue&type=template&id=82cfa9c0&scoped=true"
import script from "./FeedbackSurveyManage.vue?vue&type=script&lang=js"
export * from "./FeedbackSurveyManage.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSurveyManage.vue?vue&type=style&index=0&id=82cfa9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cfa9c0",
  null
  
)

export default component.exports